module.exports = __webpack_public_path__ + "pc/img/alipay.d8dfd707.png";